import { useEffect, useState } from "react";
import AppConst from "../apis/appconst";
import axios from "axios";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

function AddSale3() {
    const [ldata, setLdata] = useState(null);
    const [returnBillData, setReturnBillData] = useState(null);
    const [image, setImage] = useState(''); // ✅ Header image state
    const [formData, setFormData] = useState({
        medicines: [],
        med_bill_id: '',
        med_bill_original_id: '',
        med_bill_date: '',
        med_bill_type: 'return1',
        med_bill_ipd_number: '',
        med_bill_patient_number: '',
        med_bill_doctor: '',
        med_bill_ref_doctor: '',
        med_bill_phone_number: '',
        med_bill_address_of_patient: '',
        med_bill_discount: '',
        med_bill_discount_amt: '',
        med_bill_total: '',
        med_bill_final_amt: '',
        med_bill_paid: '',
        med_bill_payment_mode: '',
        med_bill_remarks: '',
        med_bill_due: '',
        med_bill_user: '',
        lab_reg_age_year: '',
        lab_reg_age_month: '',
        lab_reg_age_day: '',
        lab_reg_name_title: 'Mr.',
        lab_reg_gender: 'Male',
        return_reason: '',
        bill_number_search: '',
        page_no: 0,
        alertMsg: '',
        alertMsgTyp: '',
        search_key: '',
        isAlert: false,
    });

    // ✅ Fetch Config Data for Header Image
    const fetchConfigData = async () => {
        try {
            const res = await axios.post(
                `${AppConst.BASE_URL + AppConst.getconfig}?config_type=lab`
            );

            if (res.data.status) {
                const data = res.data;
                setImage(data.header_logo);
                console.log("Header image loaded:", data.header_logo);
            }
        }
        catch (err) {
            console.error("Error fetching config:", err);
        }
    };

    // ✅ Helper functions
    const imageUrlToBase64 = async (url) => {
        if (!url) {
            console.error("Image URL is empty or invalid.");
            return null;
        }

        try {
            const response = await fetch(url);
            if (!response.ok) {
                console.error(`Failed to fetch image. Status: ${response.status} ${response.statusText}`);
                return null;
            }

            const blob = await response.blob();

            if (!blob.type.startsWith('image/')) {
                console.error(`The provided URL did not point to an image. It pointed to a file of type: ${blob.type}`);
                return null;
            }

            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            });
        } catch (error) {
            console.error("Error fetching or converting image:", error);
            return null;
        }
    };

    const formatAge = (year, month, day) => {
        const parts = [];
        if (year) parts.push(`${year}Y`);
        if (month) parts.push(`${month}M`);
        if (day) parts.push(`${day}D`);
        return parts.length > 0 ? parts.join(" ") : "-";
    };

    const formatBillNo = (billId) => {
        return billId ? String(billId).padStart(3, "0") : "000";
    };

    const formatBillDate = (dateStr) => {
        if (!dateStr) return "-";
        const date = new Date(dateStr);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const numberToWords = (num) => {
        if (num === 0) return "Zero Rupees Only";
        
        const ones = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine"];
        const tens = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];
        const teens = ["Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
        
        const convertLessThanThousand = (n) => {
            if (n === 0) return "";
            if (n < 10) return ones[n];
            if (n < 20) return teens[n - 10];
            if (n < 100) return tens[Math.floor(n / 10)] + (n % 10 !== 0 ? " " + ones[n % 10] : "");
            return ones[Math.floor(n / 100)] + " Hundred" + (n % 100 !== 0 ? " " + convertLessThanThousand(n % 100) : "");
        };
        
        const crore = Math.floor(num / 10000000);
        const lakh = Math.floor((num % 10000000) / 100000);
        const thousand = Math.floor((num % 100000) / 1000);
        const remainder = num % 1000;
        
        let result = "";
        if (crore > 0) result += convertLessThanThousand(crore) + " Crore ";
        if (lakh > 0) result += convertLessThanThousand(lakh) + " Lakh ";
        if (thousand > 0) result += convertLessThanThousand(thousand) + " Thousand ";
        if (remainder > 0) result += convertLessThanThousand(remainder);
        
        return result.trim() + " Rupees Only";
    };

    // ✅ Generate Return Bill PDF with Header Image
    const generateReturnBillPdf = async (returnData) => {
        const doc = new jsPDF("p", "pt", "a4");
        const pageWidth = doc.internal.pageSize.getWidth();
        const margin = 30;
        let y = 40;

        // ✅ Add header image
        const headerImageBase64 = await imageUrlToBase64(image);
        const headerImageHeight = 80;

        if (headerImageBase64) {
            doc.addImage(headerImageBase64, "PNG", 0, 0, pageWidth, headerImageHeight);
            console.log("Header image added to PDF");
        } else {
            console.warn("Header image not loaded");
        }

        y = headerImageHeight + 20;
        doc.setFont("helvetica", "bold");
        doc.setFontSize(16);
        doc.text("Pharmacy Return Bill", pageWidth / 2, y, { align: "center" });
        y += 10;
        doc.rect(margin, y, pageWidth - 2 * margin, 95);

        let leftX = margin + 10;
        let rightX = pageWidth / 2 + 40;
        let lineY = y + 15;

        doc.setFont("helvetica", "bold");
        doc.setFontSize(10);
        doc.text("Return Details:", leftX, lineY);

        doc.setFont("helvetica", "normal");
        doc.setFontSize(9);

        doc.text(
            `Patient Name : ${returnData.med_bill_patient_number || 'Walk-in Customer'}`,
            leftX,
            (lineY += 15)
        );

        const ageText = formatAge(
            returnData.lab_reg_age_year,
            returnData.lab_reg_age_month,
            returnData.lab_reg_age_day
        );

        doc.text(`Age : ${ageText}`, leftX, (lineY += 15));
        doc.text(`Mobile : ${returnData.med_bill_phone_number || ''}`, leftX, (lineY += 15));
        doc.text(
            `Doctor : ${returnData.med_bill_doctor || returnData.med_bill_ref_doctor || '-'}`,
            leftX,
            (lineY += 15)
        );
        doc.text(`Return Reason : ${returnData.return_reason || '-'}`, leftX, (lineY += 15));

        lineY = y + 15;

        doc.text(`UHID : ${returnData.med_bill_ipd_number || ''}`, rightX, lineY);
        doc.text(`Return Bill No : ${formatBillNo(returnData.med_bill_id)}`, rightX, (lineY += 15));
        doc.text(`Original Bill No : ${formatBillNo(returnData.med_bill_original_id)}`, rightX, (lineY += 15));
        doc.text(`Return Date : ${formatBillDate(returnData.med_bill_date)}`, rightX, (lineY += 15));
        doc.setFont("helvetica", "bold");
        doc.text(`Bill Type : RETURN`, rightX, (lineY += 15));
        doc.setFont("helvetica", "normal");

        y += 115;

        const tableHeaders = [[
            "Sl#", "Product", "Pack", "Qty", "Batch", "Expiry", "HSN", "Discount", "MRP", "Amount"
        ]];

        const tableBody = (returnData.items || []).map((med, index) => {
            const qty = parseInt(med.med_bill_item_qty || 0);
            const mrp = parseFloat(med.med_bill_item_mrp || 0);
            const discount = parseFloat(med.med_bill_item_discount || 0);
            const total = (mrp - discount) * qty;

            return [
                index + 1,
                med.med_bill_item_medicine || '',
                (med.med_bill_item_is_loose == 1 ? "Loose" : "Package"),
                qty,
                med.med_bill_item_batch || '',
                med.med_bill_item_exp || '',
                med.med_bill_item_hsn || '',
                discount.toFixed(2),
                mrp.toFixed(2),
                total.toFixed(2),
            ];
        });

        autoTable(doc, {
            startY: y,
            head: tableHeaders,
            body: tableBody,
            theme: "grid",
            styles: { fontSize: 9, cellPadding: 4 },
            headStyles: { fillColor: [220, 220, 220], textColor: 0, fontStyle: "bold" }
        });

        y = doc.lastAutoTable.finalY + 15;

        const totalTax = (returnData.items || []).reduce(
            (sum, i) => sum + parseFloat(i.med_bill_item_tax_amt || 0),
            0
        );

        const subtotal = parseFloat(returnData.med_bill_total || 0);
        const grandTotal = parseFloat(returnData.med_bill_final_amt || 0);

        doc.setFontSize(10);
        doc.text(`Subtotal`, pageWidth - margin - 200, y);
        doc.text(`Rs ${subtotal.toFixed(2)}`, pageWidth - margin, y, { align: "right" });

        doc.text(`Total GST`, pageWidth - margin - 200, (y += 15));
        doc.text(`Rs ${totalTax.toFixed(2)}`, pageWidth - margin, y, { align: "right" });

        doc.setFont("helvetica", "bold");
        doc.text(`Total Return Amount`, pageWidth - margin - 200, (y += 20));
        doc.text(`Rs ${grandTotal.toFixed(2)}`, pageWidth - margin, y, { align: "right" });

        y += 30;
        doc.setFont("helvetica", "normal");
        doc.text(`Amount in Words: ${numberToWords(grandTotal)}`, margin, y);
        
        y += 25;
        doc.setFont("helvetica", "italic");
        doc.setFontSize(8);
        doc.text("Note: This is a return bill. Amount will be refunded as per store policy.", margin, y);
        
        y += 20;
        doc.setFont("helvetica", "bold");
        doc.setFontSize(10);
        doc.text("Authorised Signature", pageWidth - margin, y, { align: "right" });

        window.open(doc.output("bloburl"), "_blank");
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleChange1 = (e, index) => {
        if (!e || !e.target) return;
        const { name, value } = e.target;
        const name1 = name.replace(/[0-9]/g, "");

        setFormData(prev => {
            const updatedItems = [...prev.medicines];
            updatedItems[index] = {
                ...updatedItems[index],
                [name1]: value
            };

            return {
                ...prev,
                medicines: updatedItems
            };
        });
    };

    const handleRemoveRow = (index) => {
        if (formData.medicines.length === 1) {
            toast.warning("Cannot remove the last item");
            return;
        }

        Swal.fire({
            title: 'Are you sure?',
            text: "Do you want to remove this medicine from the return list?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, remove it!'
        }).then((result) => {
            if (result.isConfirmed) {
                setFormData(prev => ({
                    ...prev,
                    medicines: prev.medicines.filter((_, i) => i !== index)
                }));
                toast.success("Medicine removed from return list");
            }
        });
    };

    const searchBillByNumber = async () => {
        const billNumber = (formData.bill_number_search || "").trim();

        if (!billNumber) {
            toast.error("Please enter a bill number");
            return;
        }

        try {
            const fd = new FormData();
            fd.append('bill_number', billNumber);

            const response = await axios.post(
                AppConst.BASE_URL + AppConst.searchMedBillUrl,
                fd,
                { headers: { 'Content-Type': 'multipart/form-data' } }
            );

            if (response.data.status) {
                const bill = response.data.bill;
                const items = response.data.items || [];

                console.log("Bill Data:", bill);
                console.log("Bill Items:", items);

                const medicines = items.map((item, index) => ({
                    sn: index + 1,
                    med_bill_item_medicine: item.med_bill_item_medicine || '',
                    med_bill_item_batch: item.med_bill_item_batch || '',
                    med_bill_item_qty: '',
                    original_qty: item.med_bill_item_qty || '0',
                    med_bill_item_strips: item.med_bill_item_qty || '0',
                    med_bill_item_is_loose: item.med_bill_item_is_loose || '0',
                    med_bill_item_exp: item.med_bill_item_exp || '',
                    med_bill_item_mrp: item.med_bill_item_mrp || '',
                    med_bill_item_discount: item.med_bill_item_discount || '0',
                    med_bill_item_tax: item.med_bill_item_tax || '0',
                    med_bill_item_tax_amt: item.med_bill_item_tax_amt || '0',
                    med_bill_item_total: '0',
                    med_bill_item_hsn: item.med_bill_item_hsn || '',
                }));

                setFormData(prev => ({
                    ...prev,
                    medicines: medicines,
                    med_bill_original_id: bill.med_bill_id,
                    med_bill_date: bill.med_bill_date || '',
                    med_bill_ipd_number: bill.med_bill_ipd_number || '',
                    med_bill_patient_number: bill.med_bill_patient_number || '',
                    med_bill_doctor: bill.med_bill_ref_doctor || bill.med_bill_doctor || '',
                    med_bill_ref_doctor: bill.med_bill_ref_doctor || '',
                    med_bill_phone_number: bill.med_bill_phone_number || '',
                    med_bill_address_of_patient: bill.med_bill_address_of_patient || '',
                    lab_reg_age_year: bill.med_bill_age_year || bill.lab_reg_age_year || '',
                    lab_reg_age_month: bill.med_bill_age_month || bill.lab_reg_age_month || '',
                    lab_reg_age_day: bill.med_bill_age_day || bill.lab_reg_age_day || '',
                    lab_reg_name_title: bill.lab_reg_name_title || 'Mr.',
                    lab_reg_gender: bill.lab_reg_gender || 'Male',
                }));

                toast.success("Bill details loaded successfully");
            } else {
                toast.error(response.data.message || "Bill not found");
            }
        } catch (error) {
            console.error("Search Error:", error);
            toast.error("Error fetching bill details");
        }
    };

    useEffect(() => {
        let subtotal = 0;
        let totalQty = 0;

        formData.medicines.forEach((item) => {
            const mrp = parseFloat(item.med_bill_item_mrp) || 0;
            const qty = parseInt(item.med_bill_item_qty) || 0;
            const discount = parseFloat(item.med_bill_item_discount) || 0;

            const rowTotal = (mrp - discount) * qty;
            subtotal += rowTotal;
            totalQty += qty;
        });

        setFormData((prev) => ({
            ...prev,
            med_bill_total: subtotal.toFixed(2),
            med_bill_final_amt: subtotal.toFixed(2),
            total_qty: totalQty,
        }));
    }, [formData.medicines]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        const hasReturnItems = formData.medicines.some(m => parseInt(m.med_bill_item_qty) > 0);
        
        if (!hasReturnItems) {
            toast.error("Please enter return quantity for at least one medicine");
            return;
        }

        const invalidItems = formData.medicines.filter(m => 
            parseInt(m.med_bill_item_qty) > parseInt(m.original_qty)
        );

        if (invalidItems.length > 0) {
            toast.error("Return quantity cannot exceed original quantity");
            return;
        }

        if (!formData.return_reason) {
            toast.error("Please enter return reason");
            return;
        }

        const fd = new FormData();

        fd.append('med_bill_original_id', formData.med_bill_original_id);
        fd.append('med_bill_date', formData.med_bill_date);
        fd.append('med_bill_type', 'return1');
        fd.append('med_bill_ipd_number', formData.med_bill_ipd_number);
        fd.append('med_bill_patient_number', formData.med_bill_patient_number);
        fd.append('med_bill_doctor', formData.med_bill_doctor);
        fd.append('med_bill_ref_doctor', formData.med_bill_ref_doctor);
        fd.append('med_bill_phone_number', formData.med_bill_phone_number);
        fd.append('med_bill_address_of_patient', formData.med_bill_address_of_patient);
        fd.append('med_bill_total', formData.med_bill_total);
        fd.append('med_bill_final_amt', formData.med_bill_final_amt);
        fd.append('med_bill_remarks', formData.return_reason);
        fd.append('lab_reg_age_year', formData.lab_reg_age_year);
        fd.append('lab_reg_age_month', formData.lab_reg_age_month);
        fd.append('lab_reg_age_day', formData.lab_reg_age_day);
        
        const returnItems = formData.medicines.filter(m => parseInt(m.med_bill_item_qty) > 0);
        fd.append('med_items', JSON.stringify(returnItems));
        fd.append('med_bill_user', ldata.user_id);

        try {
            const response = await axios.post(
                AppConst.BASE_URL + AppConst.createReturnBillUrl,
                fd,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                }
            );

            if (response.data.status) {
                const returnBillInfo = {
                    med_bill_id: response.data.return_bill_id || formData.med_bill_id,
                    med_bill_original_id: formData.med_bill_original_id,
                    med_bill_date: formData.med_bill_date,
                    med_bill_ipd_number: formData.med_bill_ipd_number,
                    med_bill_patient_number: formData.med_bill_patient_number,
                    med_bill_doctor: formData.med_bill_doctor,
                    med_bill_ref_doctor: formData.med_bill_ref_doctor,
                    med_bill_phone_number: formData.med_bill_phone_number,
                    lab_reg_age_year: formData.lab_reg_age_year,
                    lab_reg_age_month: formData.lab_reg_age_month,
                    lab_reg_age_day: formData.lab_reg_age_day,
                    med_bill_total: formData.med_bill_total,
                    med_bill_final_amt: formData.med_bill_final_amt,
                    return_reason: formData.return_reason,
                    items: returnItems
                };

                setReturnBillData(returnBillInfo);

                Swal.fire({
                    icon: 'success',
                    title: 'Success!',
                    html: `
                        <p>${response.data.success || 'Return processed successfully'}</p>
                        <button id="printBtn" class="btn btn-primary mt-3">
                            <i class="ri-printer-line"></i> Print Return Bill
                        </button>
                    `,
                    showConfirmButton: true,
                    confirmButtonText: 'Go to Return List',
                    didOpen: () => {
                        const printBtn = document.getElementById('printBtn');
                        printBtn.addEventListener('click', () => {
                            generateReturnBillPdf(returnBillInfo);
                        });
                    }
                }).then(() => {
                    sessionStorage.removeItem("opd_dt");
                    window.location.href = "/sale_return";
                });
            } else {
                toast.error(response.data.success || 'Failed to process return');
            }
        } catch (error) {
            console.error(error);
            toast.error('Failed to process return');
        }
    };

    useEffect(() => {
        const storedData = sessionStorage.getItem("ldata");
        if (storedData) {
            const parsed = JSON.parse(storedData);
            setLdata(parsed);
        }

        // ✅ Fetch header image
        fetchConfigData();

        const today = new Date().toISOString().split('T')[0];
        setFormData(prev => ({
            ...prev,
            med_bill_date: today
        }));
    }, []);

    const handleAutoGenderChange = (e) => {
        const { value } = e.target;
        let genderValue = "";

        if (value === "Mr." || value === "Master") {
            genderValue = "Male";
        } else if (value === "Mr's" || value === "Miss") {
            genderValue = "Female";
        } else {
            genderValue = "Other";
        }

        setFormData((prev) => ({
            ...prev,
            lab_reg_name_title: value,
            lab_reg_gender: genderValue
        }));
    };

    return (
        <div className="page-content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-xxl-12">
                        <div className="card">
                            <div className="card-body">
                                <h5>Pharmacy Sale Return</h5>
                                <br />
                                <div className="live-preview">
                                    <form onSubmit={handleSubmit}>
                                        <div className="row">
                                            <div className="col-md-8">
                                                <label className="form-label">Search Bill Number</label>
                                                <div className="input-group">
                                                    <input
                                                        name="bill_number_search"
                                                        onChange={handleChange}
                                                        value={formData.bill_number_search}
                                                        className="form-control"
                                                        placeholder="Enter Bill Number (e.g., 016)"
                                                        type="text"
                                                    />
                                                    <button
                                                        type="button"
                                                        className="btn btn-primary"
                                                        onClick={searchBillByNumber}
                                                    >
                                                        <i className="ri-search-line"></i> Search
                                                    </button>
                                                </div>
                                            </div>

                                            <div className="col-md-12"><br /><br /></div>

                                            <div className="col-md-6">
                                                <label className="form-label">Patient Name</label>
                                                <div className="row">
                                                    <div className="col-md-3">
                                                        <select
                                                            className="form-control"
                                                            name="lab_reg_name_title"
                                                            onChange={handleAutoGenderChange}
                                                            value={formData.lab_reg_name_title}
                                                            disabled
                                                        >
                                                            <option value="Mr.">Mr.</option>
                                                            <option value="Mr's">Mr's</option>
                                                            <option value="Miss">Miss</option>
                                                            <option value="Master">Master</option>
                                                            <option value="Other">Other</option>
                                                        </select>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Patient Name"
                                                            name="med_bill_patient_number"
                                                            value={formData.med_bill_patient_number}
                                                            readOnly
                                                        />
                                                    </div>
                                                    <div className="col-md-3">
                                                        <select
                                                            className="form-control"
                                                            name="lab_reg_gender"
                                                            value={formData.lab_reg_gender}
                                                            disabled
                                                        >
                                                            <option value="Male">Male</option>
                                                            <option value="Female">Female</option>
                                                            <option value="Other">Other</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <label className="form-label">Age</label>
                                                <div className="row">
                                                    <div className="col-md-4">
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            placeholder="Year"
                                                            value={formData.lab_reg_age_year}
                                                            readOnly
                                                        />
                                                    </div>
                                                    <div className="col-md-4">
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            placeholder="Month"
                                                            value={formData.lab_reg_age_month}
                                                            readOnly
                                                        />
                                                    </div>
                                                    <div className="col-md-4">
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            placeholder="Day"
                                                            value={formData.lab_reg_age_day}
                                                            readOnly
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <br />
                                                <label className="form-label">Referring Doctor</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="med_bill_doctor"
                                                    value={formData.med_bill_doctor}
                                                    readOnly
                                                    placeholder="Doctor name"
                                                />
                                            </div>

                                            <div className="col-md-6">
                                                <br />
                                                <label className="form-label">Return Reason <span className="text-danger">*</span></label>
                                                <input
                                                    name="return_reason"
                                                    onChange={handleChange}
                                                    value={formData.return_reason}
                                                    className="form-control"
                                                    placeholder="Enter Return Reason"
                                                    type="text"
                                                    required
                                                />
                                            </div>

                                            <div className="col-md-6">
                                                <br />
                                                <label className="form-label">Phone Number</label>
                                                <input
                                                    className="form-control"
                                                    value={formData.med_bill_phone_number}
                                                    readOnly
                                                />
                                            </div>

                                            <div className="col-md-6">
                                                <br />
                                                <label className="form-label">Sale Date</label>
                                                <input
                                                    className="form-control"
                                                    value={formData.med_bill_date}
                                                    readOnly
                                                />
                                            </div>

                                            <div className="col-md-12">
                                                <br /><br />
                                                <h6>Medicines to Return</h6>
                                                <small className="text-muted">Enter the quantity you want to return for each medicine</small>
                                                <br /><br />
                                            </div>

                                            <div className="col-md-12">
                                                <div className="table-responsive">
                                                    <table className="table table-bordered">
                                                        <thead className="table-light">
                                                            <tr>
                                                                <th>S. No.</th>
                                                                <th>Medicine</th>
                                                                <th>Batch</th>
                                                                <th>Original Qty</th>
                                                                <th>Return Qty</th>
                                                                <th>Is Loose</th>
                                                                <th>Expiry</th>
                                                                <th>MRP</th>
                                                                <th>Total</th>
                                                                {formData.medicines.length > 1 && <th>Action</th>}
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {formData.medicines.length === 0 ? (
                                                                <tr>
                                                                    <td colSpan="10" className="text-center text-muted">
                                                                        Search for a bill to load medicines
                                                                    </td>
                                                                </tr>
                                                            ) : (
                                                                formData.medicines.map((item, index) => (
                                                                    <tr key={index}>
                                                                        <td>{index + 1}</td>
                                                                        <td>{item.med_bill_item_medicine}</td>
                                                                        <td>{item.med_bill_item_batch}</td>
                                                                        <td>
                                                                            <span className="badge bg-info">
                                                                                {item.original_qty}
                                                                            </span>
                                                                        </td>
                                                                        <td>
                                                                            <input
                                                                                type="number"
                                                                                className="form-control"
                                                                                name={`med_bill_item_qty${index}`}
                                                                                value={item.med_bill_item_qty}
                                                                                onChange={(e) => {
                                                                                    const val = parseInt(e.target.value) || 0;
                                                                                    if (val > parseInt(item.original_qty)) {
                                                                                        toast.error("Return qty cannot exceed original qty");
                                                                                        return;
                                                                                    }
                                                                                    handleChange1(e, index);
                                                                                }}
                                                                                min="0"
                                                                                max={item.original_qty}
                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            {item.med_bill_item_is_loose === "1" ? "Yes" : "No"}
                                                                        </td>
                                                                        <td>{item.med_bill_item_exp}</td>
                                                                        <td>₹{item.med_bill_item_mrp}</td>
                                                                        <td>
                                                                            ₹{((parseFloat(item.med_bill_item_mrp) - parseFloat(item.med_bill_item_discount)) * parseInt(item.med_bill_item_qty || 0)).toFixed(2)}
                                                                        </td>
                                                                        {formData.medicines.length > 1 && (
                                                                            <td>
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-danger btn-sm"
                                                                                    onClick={() => handleRemoveRow(index)}
                                                                                    title="Remove this medicine"
                                                                                >
                                                                                    <i className="ri-delete-bin-line"></i>
                                                                                </button>
                                                                            </td>
                                                                        )}
                                                                    </tr>
                                                                ))
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>

                                            {formData.medicines.length > 0 && (
                                                <div className="col-md-12">
                                                    <div className="card">
                                                        <div className="card-body">
                                                            <h6>Return Summary</h6>
                                                            <p className="d-flex justify-content-between">
                                                                <span>Total Return Amount:</span>
                                                                <span className="fw-bold">₹{formData.med_bill_final_amt || "0.00"}</span>
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                            <div className="col-lg-12">
                                                <div className="text-end">
                                                    <button 
                                                        type="submit" 
                                                        className="btn btn-primary"
                                                        disabled={formData.medicines.length === 0}
                                                    >
                                                        Process Return
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AddSale3;